import { Button, ButtonSize, ButtonVariant, Image, Modal, ModalSize, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { setIsOverlayLogin, useAppDispatch, useTranslation } from "@next-platform/client-common-core";
import { useCallback } from "react";

import Trans from "@/components/Trans/Trans";

interface INsfwPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function NsfwPromptModal(props: INsfwPromptModalProps) {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const onClickRegister = useCallback(() => {
    dispatch(setIsOverlayLogin(true));
    onClose();
  }, [dispatch, onClose]);

  return (
    <Modal title={t("auth:nsfwAccess.modal.title")} className="dark:!bg-gray-6" size={ModalSize.LARGE} open={isOpen} onOpenChange={onClose}>
      <Image src="/Assets/nsfwPromptImage.webp" alt={t("auth:nsfwAccess.modal.title")} height={309} className="rounded-[20px] object-top" />
      <Text variant={TextVariants.LABEL_LARGE_REGULAR} className="text-gray-12">
        <Trans i18nKey="auth:nsfwAccess.modal.description" />
      </Text>
      <Button
        size={ButtonSize.LARGE}
        variant={ButtonVariant.TRANSPARENT}
        className="w-full gap-lg bg-gradient-to-r from-purple-9 to-blue-9 text-white"
        onClick={onClickRegister}
      >
        <Trans i18nKey="auth:nsfwAccess.modal.cta.createAccount" />
      </Button>
    </Modal>
  );
}
